import { DataFieldListItem } from "@iventis/domain-model/model/dataFieldListItem";
import { EventBlockSystemDataFieldType } from "@iventis/domain-model/model/eventBlockSystemDataFieldType";
import { DataField } from "@iventis/domain-model/model/dataField";
import { MapObjectImagePayload } from "@iventis/domain-model/model/mapObjectImagePayload";
import { RepeatedTimeRange } from "@iventis/domain-model/model/repeatedTimeRange";
import { TimeRange, TimeSpan } from "./time-span";
import { MapObjectRepeatedTimeRangeValue } from "./date-filtering";

export type DataFieldValueTypes =
    | string
    | number
    | DataFieldListItem
    | Date
    | boolean
    | DataFieldListItem[]
    | string[]
    | TimeSpan
    | TimeRange
    | AllowedMapObjectImagePayloads
    | MapObjectRepeatedTimeRangeValue[]
    | RepeatedTimeRange[];

export type AllowedMapObjectImagePayloads = MapObjectImagePayload | Pick<MapObjectImagePayload, "imageData"> | Pick<MapObjectImagePayload, "imageName">;

export interface AdditionalDataFieldProperties extends DataField {
    required?: boolean;
    systemDataField?: EventBlockSystemDataFieldType;
    namingOrder?: number;
}

export interface RepeatedTimeRangeAsDate extends Omit<RepeatedTimeRange, "startDate" | "endDate" | "startTime" | "endTime"> {
    startTime: Date;
    endTime: Date;
    startDate: Date;
    endDate: Date;
}
